import React, { useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { registerAdmin } from "../utils/Api/ApiCalls";

// Validation schema
const schema = yup.object().shape({
  fullname: yup.string().required("Fullname is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
});

const AddAdmin = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [load, setLoad] = useState(false);

  const onAddAdmin = handleSubmit(async (data) => {
    console.log('Hit');
    setLoad(true);
    try {
        console.log(data);
      const response = await registerAdmin(data);
      Swal.fire({
        icon: "success",
        title: "Admin added successfully!",
        text: response.message,
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        navigate("/admin-dashboard");
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "Something went wrong",
      });
    } finally {
      setLoad(false);
    }
  });

  return (
    <div className="col-lg-9">
      <section className="content-body p-xl-4">
        <h4>Add New Admin</h4>
        <form onSubmit={onAddAdmin}>
          <div className="row">
            <div className="col-lg-6 mb-3">
              <label className="form-label">Full Name</label>
              <input
                {...register("fullname")}
                className="form-control"
                type="text"
                placeholder="Enter fullname"
              />
              {errors.fullname && <p className="text-danger">{errors.fullname.message}</p>}
            </div>
            <div className="col-lg-6 mb-3">
              <label className="form-label">Email</label>
              <input
                {...register("email")}
                className="form-control"
                type="email"
                placeholder="Enter email address"
              />
              {errors.email && <p className="text-danger">{errors.email.message}</p>}
            </div>
            <div className="col-lg-12 mb-3">
              <label className="form-label">Password</label>
              <input
                {...register("password")}
                className="form-control"
                type="password"
                placeholder="Enter password"
              />
              {errors.password && <p className="text-danger">{errors.password.message}</p>}
            </div>
          </div>
          {load ? (
            <button disabled className="btn btn-primary" style={{ background: "silver" }} type="submit">
              Loading...
            </button>
          ) : (
            <button className="btn btn-primary" type="submit">
              Add Admin
            </button>
          )}
        </form>
      </section>
    </div>
  );
};

export default AddAdmin;
